import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpStatusCode
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserAuthService } from 'src/app/modules/auth/services/user.service';
import { DataResponseWrapper } from '../classes/core/api/data-response-wrapper';
import { IValidationErrors } from '../interfaces/core/api/validation-error';

@Injectable({
    providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private toastr: ToastrService,
        private userAuthService: UserAuthService
    ) {}
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (event.body?.success == false) {
                        this.toastr.error(
                            `${event.body.result?.message}`,
                            'Error'
                        );
                    }
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.error instanceof ErrorEvent) {
                    this.toastr.error('Something went wrong!', 'Error');
                }
                if (error.error instanceof ProgressEvent && error.status == 0) {
                    this.toastr.error('API Unavailable', 'Error');
                } else {
                    if (
                        error.status == HttpStatusCode.Unauthorized ||
                        error.status == HttpStatusCode.Forbidden
                    ) {
                        this.userAuthService.navigateToUnauthorised();
                    } else {
                        // server-side error
                        const errorResponse =
                            error.error as DataResponseWrapper<IValidationErrors>;

                        if (errorResponse.data?.errors) {
                            this.toastr.error(
                                errorResponse.data.errors[0].value,
                                'Error'
                            );
                        } else {
                            this.toastr.error(
                                errorResponse.message ??
                                    'Something went wrong!',
                                'Error'
                            );
                        }
                    }
                }
                return throwError(error);
            })
        );
    }
}
